export default (that) => [
  {
    field: 'orderPackingCode',
    width: 50,
    align: 'center',
    merge: true,
    type: 'seq'
  },
  {
    title: '站位',
    field: 'orderPackingCode',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    mergeByKey: true,
    showHeaderOverflow: true,
    visible: false
  },
  {
    title: that.$l('INDEX.order_package_packingType') || '装箱方式',
    field: 'v_packingType',
    width: 90,
    headerAlign: 'center',
    align: 'center',
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true

  },
  {
    title: that.$l('INDEX.order_packing_outBillType') || '出单类型',
    field: 'v_outBillType',
    width: 90,
    headerAlign: 'center',
    align: 'center',
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_package_materialNo') || '物料编号',
    field: 'materialNo',
    width: 140,
    merge: true,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_package_materialName') || '物料名称',
    field: 'materialName',
    minWidth: 160,
    merge: true,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_package_materialSpec') || '箱规格',
    field: 'materialSpec',
    width: 110,
    merge: true,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_time') || '修改时间',
    field: 'modifyTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_product_information') || '产品信息',
    align: 'center',
    children: [
      {
        title: that.$l('INDEX.order_packing_inPackageQty') || '装箱入数',
        field: 'inPackageQty',
        width: 120,
        align: 'center',
        showHeaderOverflow: true,
        showOverflow: true,
      },
      {
        title: that.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
        field: 'orderGoodsNo',
        width: 150,
        align: 'center',
        showOverflow: true,
        showHeaderOverflow: true,
      },
      {
        title:
          that.$l('INDEX.order_goods_label_identifyGoodsNo') ||
          '产品识别编号',
        field: 'identifyGoodsNo',
        width: 230,
        headerAlign: 'center',
        align: 'left',
        showHeaderOverflow: true,
        showOverflow: true,
      },
      {
        title:
          that.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
        field: 'orderGoodsDisplayName',
        minWidth: 500,
        align: 'left',
        headerAlign: 'center',
        showHeaderOverflow: true,
        showOverflow: true,
      },
    ]
  }
]
